import { ModelNotificationEvent } from './ModelNotificationEvent.js';
import { engineUtils, } from '../../services/EngineUtils.js';
export class LookupMutatorCorrectionEvent extends ModelNotificationEvent {
    constructor(target, optionsCorrections) {
        super(target);
        this.target = target;
        this.optionsCorrections = optionsCorrections;
    }
}
export class LookupMutatorCorrectionEventBuilder {
    constructor(optionPath, propertyNames, resolutionSchema) {
        this.optionPath = optionPath;
        this.propertyNames = propertyNames;
        this.resolutionSchema = resolutionSchema;
        this.optionsCorrections = [];
    }
    isAnyDiff() {
        return this.optionsCorrections.length > 0;
    }
    build(model, lookup) {
        return new LookupMutatorCorrectionEvent({ model, lookup }, this.optionsCorrections);
    }
    appendDiff(path, oldOptionValue, newOptionValue) {
        const lookupProperties = this.resolutionSchema.getAllOptionResolutionProperties(path);
        const ignoredProperties = path === this.optionPath ? ['_id'].concat(this.propertyNames) : ['_id'];
        const propertiesToCompare = lookupProperties.filter(p => !ignoredProperties.includes(p));
        const propertiesChanges = engineUtils.objectDiff(oldOptionValue, newOptionValue, propertiesToCompare);
        if (Object.keys(propertiesChanges).length) {
            this.optionsCorrections.push({
                optionPath: path,
                propertiesChanges
            });
        }
    }
}
//# sourceMappingURL=LookupMutatorCorrectionEvent.js.map